export const canvasElementTypes = {
  IMAGE: 'IMAGE',
  '3D_MODEL': '3D_MODEL',
  TEXT: 'TEXT',
  VIDEO: 'VIDEO',
  GLTF: 'GLTF',
  GLB: 'GLB',
  AUDIO: 'AUDIO',
};

export const canvasDimension = {
  HEIGHT: 640,
  WIDTH: 360,
};

export const screenCanvasElementTypes = {
  BACKGROUND: 'BACKGROUND',
  BACKGROUND_COLOR: 'BACKGROUND_COLOR',
  TEXT: 'TEXT',
  BUTTON: 'BUTTON',
  CTA_BTN: 'CTA_BTN',
  TANDC: 'TANDC',
  IMAGE: 'IMAGE',
  INPUT: 'INPUT',
  SHARE_BTN: 'SHARE_BTN',
  LEAD_SKIP_BTN: 'LEAD_SKIP_BTN',
  ELEMENT: 'ELEMENT',
  COUPON: 'COUPON',
};
